import { createContext } from 'react';

export interface FeatureFlagsContextValue {
  /** Evaluated map { featureKey: enabled } for the current fund + user. */
  flags: Record<string, boolean>;
  isLoading: boolean;
  isEnabled: (featureKey: string) => boolean;
}

const FeatureFlagsContext = createContext<FeatureFlagsContextValue | undefined>(undefined);
export default FeatureFlagsContext;
